import Plus from '../../../components/svg/plus'
import { Desktop } from '../../../components/media'

export default function FilterHandle({ name, onClick, children }) {
  return (
    <button className='flatBtn filterBtn' onClick={() => onClick(name)}>
      {children}
      <Desktop>
        <Plus width='12' height='12' fill='var(--primary-color)' />
      </Desktop>

      <style jsx>{`
        .filterBtn {
          display: inline-block;
          max-width: 21.3rem;
          width: 100%;
          height: 4.2rem;
          padding: 0 2.5rem 0 1.9rem;
          border-radius: 2.1rem;
          border: 0.2rem solid #e9ecf2;
          text-align: left;
          color: var(--secondary-text-color);
          font-size: 1.6rem;
          font-weight: 700;

          &:hover,
          &:active {
            border-color: var(--primary-color);
            color: var(--primary-color);
          }

          :global(svg) {
            position: absolute;
            top: 50%;
            right: 1.25rem;
            transform: translateY(-50%);
          }
        }

        @media (max-width: 1510px) {
          .filterBtn {
            font-size: 1.4rem;
          }
        }

        @media (max-width: 1385px) {
          .filterBtn {
            font-size: 1.3rem;
          }
        }

        @media (max-width: 1024px) {
          .filterBtn {
            height: 3.5rem;
            padding: 0;
            text-align: center;
            font-size: 1.2rem;
          }
        }
      `}</style>
    </button>
  )
}
